import React from 'react';

import { Header } from '../ResponsiveLandingPage/components/Header';
import { Footer } from '../ResponsiveLandingPage/components/Footer';
import { ContentPage } from './components/ContentPage';

import './NewFAQ.css';

export function NewFAQ() {
  return (
    <div className="newFaqPage">
      <Header />
      <div className="newFaqAlign">
        <div className="newFaqContent">
          <ContentPage />
        </div>
      </div>
      <Footer />
    </div>
  );
}
